import { render, staticRenderFns } from "./CarrierDestinationDeleteButton.vue?vue&type=template&id=0d452f58&scoped=true&"
import script from "./CarrierDestinationDeleteButton.vue?vue&type=script&lang=js&"
export * from "./CarrierDestinationDeleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d452f58",
  null
  
)

export default component.exports